import { QueryModelCore } from "@/core/model.core";

export default class Basic {
  /**
   * 获取字典列表
   * @param {string} dicName 字典名称
   */
  async dicList(dicName) {
    const result = await new QueryModelCore('/api-admin/app/sysDic/listDicDesc').get({ dicName });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取国家列表(分页)
   * @param {Object} params {
   *    @param {number} current
   *    @param {number} size
   * }
   */
  async countryPagingList(params) {
    const result = await new QueryModelCore('/api-tmc/basic/getCountryList').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取所有城市数据
   */
  async getAllCityList(params) {
    const result = await new QueryModelCore('/api-prod/app/getAllCity').get(params);
    const { dataMap } = result;
    return dataMap;
  }
}